import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_7254_143370)", children: /* @__PURE__ */ jsx("path", { d: "M4 11V13L20 13V11L4 11Z", fill: "#666666" }) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_7254_143370", children: /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "white" }) }) })
] });
const ForwardRef = forwardRef(SvgMinus);
export { ForwardRef as ReactComponent };
